import { useEffect, useState } from "react";
import { HelpCircle, Ban } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useFlash } from "../lib/flash";

function PageRow({ p, current, busy, onPick }) {
  const isCurrent = p.id === current;
  return (
    <li className={"fbp-row" + (p.eligible ? "" : " off")} data-testid={`fb-pick-page-${p.id}`}>
      {p.picture ? <img src={p.picture} alt="" width="40" height="40" /> : <span className="fbp-ph">{(p.name || "?").slice(0, 1)}</span>}
      <div className="fbp-txt">
        <b>{p.name}</b>
        {isCurrent && <small className="pill">Nuværende side</small>}
        {!p.eligible && <small className="fbp-reason" data-testid={`fb-pick-reason-${p.id}`}><Ban size={13} /> {p.reason}</small>}
      </div>
      {p.eligible && (
        <button type="button" className="btn primary small" disabled={busy} onClick={() => onPick(p)} data-testid={`fb-pick-select-${p.id}`}>
          {isCurrent ? "Behold" : "Vælg"}
        </button>
      )}
    </li>
  );
}

export default function FbPagePicker({ onDone }) {
  const flash = useFlash();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/facebook/pages/pick").then((r) => setD(r.data)).catch((e) => setErr(apiError(e.response?.data?.detail)));
  }, []);
  const pick = async (p) => {
    if (d.current_page_id && p.id !== d.current_page_id &&
      !window.confirm(`Skift til siden «${p.name}»? Aktive tilbud, der er slået op på den gamle side, får ikke længere svar på nye kommentarer.`)) return;
    setBusy(true);
    try {
      const r = await api.post("/facebook/pages/pick", { page_id: p.id });
      flash(r.data.flash);
      onDone(true);
    } catch (e) {
      setErr(apiError(e.response?.data?.detail));
      setBusy(false);
    }
  };
  const cancel = async () => {
    await api.delete("/facebook/pages/pick").catch(() => {});
    onDone(false);
  };
  return (
    <div className="fbp" data-testid="fb-page-picker">
      <h3>Vælg Facebook-side</h3>
      <p className="muted">Vælg den side, denne butik skal bruge. Én side kan kun være forbundet til én butik.</p>
      {err && <div className="notice error" data-testid="fb-pick-error">{err}</div>}
      {!d && !err && <p className="muted">Henter dine sider…</p>}
      {d && (
        <ul className="fbp-list" data-testid="fb-pick-list">
          {d.pages.map((p) => <PageRow key={p.id} p={p} current={d.current_page_id} busy={busy} onPick={pick} />)}
        </ul>
      )}
      <div className="fbp-help" data-testid="fb-pick-help">
        <b><HelpCircle size={14} /> Mangler din side?</b>
        <p>Facebook har kun givet adgang til de sider, du valgte. Tryk «Forbind igen», vælg «Rediger tidligere indstillinger», og sæt flueben ved siden.</p>
        <p>Du kan også gå til Facebook → Indstillinger og privatliv → Indstillinger → Virksomhedsintegrationer → JaTak Pro → Vis og rediger.</p>
      </div>
      <button type="button" className="btn small" onClick={cancel} data-testid="fb-pick-cancel">Annullér</button>
    </div>
  );
}
